import React from 'react';
import Modal, {
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalFooterPrimaryButton,
  ModalHeader,
} from '../../../../components/modal/Modal';
import { useTranslate } from '../../../../../core/translate';
import DriveTypeDetail from '../../../../common/driveTypeDetail/DriveTypeDetail';

const DriveTypeDetailModal = ({ onClose }) => {
  const translate = useTranslate();

  const analyticsKey = 'performance details';
  const header = translate('performance.details.v3');
  const buttonLabel = translate('byo.page.general.ok');

  return (
    <Modal isOpen={true} contentLabel={header} onRequestClose={onClose}>
      <ModalHeader
        text={header}
        analyticsKey={analyticsKey}
        onClose={onClose}
      />
      <ModalBody>
        <ModalContent>
          <DriveTypeDetail />
        </ModalContent>
      </ModalBody>
      <ModalFooter>
        <ModalFooterPrimaryButton
          className="option-details__footer-button stat-button-link"
          onSelect={onClose}
          data-dtm={header}>
          {buttonLabel}
        </ModalFooterPrimaryButton>
      </ModalFooter>
    </Modal>
  );
};

export default DriveTypeDetailModal;
